import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';
import { Link } from 'react-router-dom';

import Loading from 'components/App/Loading';
import Selection from 'components/App/Selection';
import { BOOKING_STATUS, LOCATIONS } from 'constants/index';
import { convertIsoDateToString } from 'utils';
import formatMoney from 'utils/formatMoney';

import styles from './CustomerServiceHistoryTable.module.scss';

const STATUS_LABELS = {
  PENDING: 'Chờ thanh toán',
  MODIFIED: 'Đã điều chỉnh',
  PAID: 'Đã đặt phòng',
  SUCCESS: 'Đã hoàn thành',
  PAYMENT_FAILED: 'Thanh toán thất bại',
  CANCELLED_BY_USER: 'Đã huỷ',
  CANCELLED_BY_PLACE: 'Đã huỷ',
  ABSENT_CHECK_IN: 'Không nhận phòng',
};

const STATUS_FILTER_OPTIONS = [
  { value: 'ALL', label: 'Trạng thái' },
  { value: 'PENDING', label: 'Chờ thanh toán' },
  { value: 'MODIFIED', label: 'Đã điều chỉnh' },
  { value: 'PAID', label: 'Đã đặt phòng' },
  { value: 'SUCCESS', label: 'Đã hoàn thành' },
  { value: 'PAYMENT_FAILED', label: 'Thanh toán thất bại' },
  { value: 'CANCELLED_BY_USER', label: 'Đã huỷ bởi khách hàng' },
  { value: 'CANCELLED_BY_PLACE', label: 'Đã huỷ bởi khách sạn' },
  { value: 'ABSENT_CHECK_IN', label: 'Không nhận phòng' },
];

function CustomerServiceHistoryTable({
  data,
  loading,
  bookingStatus,
  onChangeStatus,
}) {
  const bookingsList = React.useMemo(
    () => (Array.isArray(data) ? data : []),
    [data],
  );

  return (
    <div className={styles.Component}>
      <Loading loading={loading} loaderOnPage />

      <div className="Filter__Container mb-20">
        <Selection
          value={bookingStatus}
          onChange={(opt) => onChangeStatus({ target: { value: opt?.value || 'ALL' } })}
          options={STATUS_FILTER_OPTIONS}
          placeholder="Trạng thái"
          selectedClassName="Filter__Select"
          isHiddenSearchable={false}
        />
      </div>

      <Table responsive className="Table">
        <thead className="Table__Header">
          <tr className="Table__Header__Row">
            <th className="Table__Header__Row__Content">Mã đặt phòng</th>
            <th className="Table__Header__Row__Content">Ngày nhận phòng</th>
            <th className="Table__Header__Row__Content">Ngày trả phòng</th>
            <th className="Table__Header__Row__Content">Tên phòng</th>
            <th className="Table__Header__Row__Content">Ngày đặt phòng</th>
            <th className="Table__Header__Row__Content">Tình trạng</th>
            <th className="Table__Header__Row__Content">Giá phòng</th>
          </tr>
        </thead>

        <tbody className="Table__Body">
          {bookingsList.map((booking) => (
            <tr className="Table__Body__Row" key={booking._id}>
              <td className="Table__Body__Row__Content">
                <div className="d-flex flex-column action-hover-container">
                  <span className="booking-id-text">{booking.orderId}</span>
                  <Link
                    to={`${LOCATIONS.MANAGER_BOOKING}/${booking._id}`}
                    className="action-link"
                  >
                    Xem chi tiết
                  </Link>
                </div>
              </td>
              <td className="Table__Body__Row__Content">
                {convertIsoDateToString(booking.startedAt)}
              </td>
              <td className="Table__Body__Row__Content">
                {convertIsoDateToString(booking.endedAt)}
              </td>
              <td className="Table__Body__Row__Content">
                {booking.rooms?.map((room) => room.name).join(', ') ||
                  booking.name}
              </td>
              <td className="Table__Body__Row__Content">
                {convertIsoDateToString(booking.createdAt)}
              </td>
              <td className="Table__Body__Row__Content">
                <span className="status-text">
                  {STATUS_LABELS[booking.bookingStatus] ||
                    BOOKING_STATUS[booking.bookingStatus]?.label ||
                    booking.bookingStatus}
                </span>
              </td>
              <td className="Table__Body__Row__Content price-cell">
                {formatMoney.format(
                  booking.totalDiscountedPrice || booking.totalPrice,
                )}
              </td>
            </tr>
          ))}

          {bookingsList.length === 0 && (
            <tr>
              <td colSpan="7" className="text-center py-4 text-muted">
                Không có dữ liệu
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  );
}

CustomerServiceHistoryTable.propTypes = {
  data: PropTypes.instanceOf(Array),
  loading: PropTypes.bool,
  bookingStatus: PropTypes.string,
  onChangeStatus: PropTypes.func,
};

CustomerServiceHistoryTable.defaultProps = {
  data: [],
  loading: false,
  bookingStatus: 'ALL',
  onChangeStatus: () => {},
};

export default CustomerServiceHistoryTable;
